import { Box, Typography } from "@mui/material";

// FOOTER
export default function Footer() {
    return (
        <Box component="footer" sx={{ py: 3, px: 5, userSelect: 'none' }}>
            <Typography component="p" variant="body1" color="white" fontFamily="Public Sans">
                © ProductionRP {new Date().getFullYear()}
            </Typography>
        </Box>
    )
}
